
export const FIELDNAME_CONTACT = 'Contact';
export const BUTTON_CONTACT_VALUE = 'Let\'s Work Together';
export const BUTTON_ABOUT_ME_VALUE = 'Let\'s Get Started';